import { ComponentProps } from 'preact';
import { ComponentMessageItem, ComponentMessageContainer } from '../UNSAFE_ComponentMessage';
import { useFormContext } from '../hooks/UNSAFE_useFormContext';
import { useFormFieldContext } from '../hooks/UNSAFE_useFormFieldContext';
import { InlineHelp } from './InlineHelp';
import { InlineRequired } from './InlineRequired';
import { InlineUserAssistanceContainer } from './InlineUserAssistanceContainer';

export type UserAssistanceDensityType = 'reflow' | 'efficient';

type Props = {
  assistiveText?: string;
  fieldLabel?: string;
  helpSourceLink?: string;
  helpSourceText?: string;
  id?: string;
  isRequiredShown?: boolean;
  requiredAlignment?: ComponentProps<typeof InlineRequired>['align'];
  messages?: ComponentMessageItem[];
  userAssistanceDensity?: UserAssistanceDensityType;
};

// This has the precedence rules for the user assistance.
export function InlineUserAssistance({
  assistiveText,
  fieldLabel,
  helpSourceLink,
  helpSourceText,
  id,
  isRequiredShown,
  requiredAlignment,
  messages = [],
  userAssistanceDensity
}: Props) {
  const { isReadonly: isFormReadonly } = useFormContext();
  const needsUserAssistanceIfNoContent =
    userAssistanceDensity === 'efficient' && isFormReadonly === false;
  const { isFocused } = useFormFieldContext();
  const uaInlineContent =
    messages.length > 0 ? (
      <ComponentMessageContainer fieldLabel={fieldLabel} messages={messages} />
    ) : (assistiveText || helpSourceLink) && isFocused ? (
      <InlineHelp
        assistiveText={assistiveText}
        sourceLink={helpSourceLink}
        sourceText={helpSourceText}
      />
    ) : isRequiredShown ? (
      <InlineRequired align={requiredAlignment} />
    ) : null;

  // when reflow we do not render unless it has content.
  // when efficient we render regardless of if it has content.
  // TODO: Get the userAssistanceDensity value from the FormContext
  return uaInlineContent || needsUserAssistanceIfNoContent ? (
    <InlineUserAssistanceContainer id={id} variant={userAssistanceDensity}>
      {uaInlineContent}
    </InlineUserAssistanceContainer>
  ) : null;
}
